<template>
	<div ref="scrollContainer" id="page-panel" class="box grow scrollable" >
    <div class="customer-top-nav no-print">
			<span class="title" >{{ $t('datagrapes.title') }}</span>
			<div class="controls">
				<el-button @click="close();">{{$t('buttons.close')}}</el-button>
        <el-button type="primary" @click="save">{{$t('common.save')}}</el-button>
			</div>
		</div>
    <el-tabs type="border-card" >
        <el-tab-pane :label="$t('datagrapes.configuration')">
          <p class="bg-accent-lighter p-10">
            <i class="el-icon-warning-outline"></i> 
            <span v-html="$t('datagrapes.instructions')"></span>
          </p>
          <el-form ref="form" :model="model" label-width="120px" label-position="top" :rules="rules">
            <el-form-item :label="$t('datagrapes.active')" >
              <el-radio-group v-model="model.active" @change="handleActive">
                <el-radio-button :label="true">{{$t('datagrapes.active')}}</el-radio-button>
                <el-radio-button :label="false">{{$t('datagrapes.inactive')}}</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('datagrapes.productSyncInd')" >
              <el-radio-group v-model="model.productSyncInd" @change="handleActive">
                <el-radio-button :label="true">{{$t('datagrapes.active')}}</el-radio-button>
                <el-radio-button :label="false">{{$t('datagrapes.inactive')}}</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('datagrapes.poSyncActiveInv')" >
              <el-radio-group v-model="model.poSyncInd" @change="handleActive">
                <el-radio-button :label="true">{{$t('datagrapes.active')}}</el-radio-button>
                <el-radio-button :label="false">{{$t('datagrapes.inactive')}}</el-radio-button>
              </el-radio-group>
            </el-form-item>

            <el-form-item :label="$t('datagrapes.inventory')" prop="inventory">
              <el-select v-model="model.inventory">
                <el-option
                  v-for="item in getSAQInventories"
                  :key="item.id"
                  :label="item.name"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('datagrapes.clientId')" prop="clientId">
                <el-input v-model="model.clientId"></el-input>
            </el-form-item>
            <el-form-item :label="$t('datagrapes.clientSecret')" prop="clientId">
                <el-input v-model="model.clientSecret" show-password></el-input>
            </el-form-item>
          </el-form>
      </el-tab-pane>
      <el-tab-pane :label="$t('datagrapes.logs')">
      </el-tab-pane>
    </el-tabs>
	</div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import DatagrapesClientAPI from '@/services/API/datagrapes.js'

export default {
  name : "Datagrapes",
  data() {
    return {
      model: {
        id: null,
        inventory: null,
        clientId: null,
        clientSecret: null,
        active: false,
        poSyncInd: null,
        productSyncInd: null,
      },
      rules : {
        
      }
    };
  },components: {

  },
	methods: {
    handleActive (active) {

    },
    close () {
			this.$router.go(-1);
		},
    initModel (datagrapesClient) {
      this.model.id = _.get(datagrapesClient, 'id');
      this.model.active = _.get(datagrapesClient, 'active') != null ? _.get(datagrapesClient, 'active') : false;
      this.model.productSyncInd = _.get(datagrapesClient, 'productSyncInd') != null ? _.get(datagrapesClient, 'productSyncInd') : false;
      this.model.poSyncInd = _.get(datagrapesClient, 'poSyncInd') != null ? _.get(datagrapesClient, 'poSyncInd') : false;
      this.model.clientId = _.get(datagrapesClient, 'clientId');
      this.model.clientSecret = _.get(datagrapesClient, 'clientSecret');
      if (_.get(datagrapesClient, 'inventory') != null) {
        this.model.inventory = {
          id: datagrapesClient.inventory.id,
        }
      }
    },
    udpatedataGrapesClient () {
      return DatagrapesClientAPI.updateDataGrapesClient(this.model.id, this.model)
      .then(() => {
        this.$message.success(this.$i18n.t('datagrapes.updateSuccess'));
      }).catch((err) => {
          if (_.get(err, 'response.data.errorCode') === 'DATAGRAPES_TEST_AUTHENTICATION_FAILED') {
            this.$message.error(this.$i18n.t('datagrapes.authenticationFaield'));
          } else {
            this.$message.error(this.$i18n.t('datagrapes.updateError'));
          }
        })
    },
    createDatagrapesClient () {
      return DatagrapesClientAPI.createDataGrapesClient(this.model)
        .then(() => {
          this.$message.success(this.$i18n.t('datagrapes.createSuccess'));
        })
        .catch((err) => {
          if (_.get(err, 'response.data.errorCode') === 'DATAGRAPES_TEST_AUTHENTICATION_FAILED') {
            this.$message.error(this.$i18n.t('datagrapes.authenticationFaield'));
          } else {
            this.$message.error(this.$i18n.t('datagrapes.createError'));
          }
        })
    },
    save () {
      return this.$refs['form'].validate()
        .then(() => {
          
            if (this.model.id == null) {
              return this.createDatagrapesClient();
            }
            return this.udpatedataGrapesClient();
        }).catch((err) => {
          this.$message.warning('Le formulaire comporte certaines erreurs ou informations manquantes!');
        })
    },
    fetchDataGrapesClient () {
      this.loading = true;
      return DatagrapesClientAPI.fetchDataGrapesClient()
        .then((datagrapesClients) => {
          this.loading = true;
          this.initModel(_.head(datagrapesClients));
        }).catch((err) => {
          console.log(err);
          this.$message.error(this.$i18n.t('common.errors.generic'));
        });
    },
    ...mapActions('controlData', ['fetchInventories']),
	},
	computed: {
    getSAQInventories () {
      const portausCompanyId = _.get(this.getCurrentPortausCompany, 'id');
      if (portausCompanyId == null) return [];
      return _.filter(this.getInventoriesByPortausCompany[portausCompanyId], inv => inv.code === 'SAQ');
    },
    ...mapState('controlData', ['inventories']),
    ...mapGetters('controlData', ['getInventoriesByPortausCompany']),
    ...mapGetters(['getCurrentPortausCompany'])
	},
	created(){
    this.fetchInventories();
    this.fetchDataGrapesClient();
	}
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';

.title {
	font-size : 1.8em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:50px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}
</style>
